'use client';

import { useCallback, useRef, useSyncExternalStore } from 'react';

type OffsetHeaders = {
  offsetPrimaryHeader: number;
  offsetPageToolbar: number;
};

const SERVER_SNAPSHOT: OffsetHeaders = { offsetPrimaryHeader: 0, offsetPageToolbar: 0 };

function getServerSnapshot(): OffsetHeaders {
  return SERVER_SNAPSHOT;
}

function isEqual(offsetsA: OffsetHeaders, offsetsB: OffsetHeaders) {
  return offsetsA.offsetPrimaryHeader === offsetsB.offsetPrimaryHeader && offsetsA.offsetPageToolbar === offsetsB.offsetPageToolbar;
}

function useOffsetHeaders(): OffsetHeaders {
  const subscribe = useCallback((onStoreChange: () => void) => {
    const resizeObserver = new ResizeObserver(onStoreChange);
    const primaryHeader = document.getElementById('primary-header');
    const pageToolbar = document.getElementById('page-toolbar');

    if (primaryHeader) resizeObserver.observe(primaryHeader);
    if (pageToolbar) resizeObserver.observe(pageToolbar);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const lastResult = useRef(SERVER_SNAPSHOT);
  const getSnapshot = useCallback(() => {
    const primaryHeader = document.getElementById('primary-header');
    const pageToolbar = document.getElementById('page-toolbar');

    const offsetPrimaryHeader = primaryHeader?.clientHeight ?? 0;
    const offsetPageToolbar = offsetPrimaryHeader + (pageToolbar?.clientHeight ?? 0);

    const result = { offsetPrimaryHeader, offsetPageToolbar };
    if (!isEqual(result, lastResult.current)) {
      lastResult.current = result;
    }

    return lastResult.current;
  }, []);

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export { useOffsetHeaders };
